import {ServiceProviderRepositoryImpl} from '../repository/ServiceProviderRepositoryImpl';
import {GetAllServiceProvidersUseCase} from '../useCases/GetAllServiceProvidersUseCase';
import {GetServiceProviderByIdUseCase} from '../useCases/GetServiceProviderByIdUseCase';
import {CreateServiceProviderUseCase} from '../useCases/CreateServiceProviderUseCase';
import {UpdateServiceProviderUseCase} from '../useCases/UpdateServiceProviderUseCase';
import {DeleteServiceProviderUseCase} from '../useCases/DeleteServiceProviderUseCase';
import {AssignBrandToProviderUseCase} from '../useCases/AssignBrandToProviderUseCase';
import {UnassignBrandFromProviderUseCase} from '../useCases/UnassignBrandFromProviderUseCase';
import {GetServiceProviderStatsUseCase} from '../useCases/GetServiceProviderStatsUseCase';
import {GetProviderBrandsUseCase} from '../useCases/GetProviderBrandsUseCase';
import {GetMyBrandsUseCase} from '../useCases/GetMyBrandsUseCase';
import {GetBrandStoresUseCase} from '../useCases/GetBrandStoresUseCase';

// Repository instance
const serviceProviderRepository = new ServiceProviderRepositoryImpl();

// Use Cases
export const getAllServiceProvidersUseCase = new GetAllServiceProvidersUseCase(serviceProviderRepository);
export const getServiceProviderByIdUseCase = new GetServiceProviderByIdUseCase(serviceProviderRepository);
export const createServiceProviderUseCase = new CreateServiceProviderUseCase(serviceProviderRepository);
export const updateServiceProviderUseCase = new UpdateServiceProviderUseCase(serviceProviderRepository);
export const deleteServiceProviderUseCase = new DeleteServiceProviderUseCase(serviceProviderRepository);
export const assignBrandToProviderUseCase = new AssignBrandToProviderUseCase(serviceProviderRepository);
export const unassignBrandFromProviderUseCase = new UnassignBrandFromProviderUseCase(serviceProviderRepository);
export const getServiceProviderStatsUseCase = new GetServiceProviderStatsUseCase(serviceProviderRepository);
export const getProviderBrandsUseCase = new GetProviderBrandsUseCase(serviceProviderRepository);
export const getMyBrandsUseCase = new GetMyBrandsUseCase(serviceProviderRepository);
export const getBrandStoresUseCase = new GetBrandStoresUseCase(serviceProviderRepository);

// Factory class for consistency with other features
export class ServiceProviderFactory {
  private static instance: ServiceProviderFactory;
  private repository: ServiceProviderRepositoryImpl;

  private constructor () {
    this.repository = new ServiceProviderRepositoryImpl();
  }

  public static getInstance (): ServiceProviderFactory {
    if (!ServiceProviderFactory.instance) {
      ServiceProviderFactory.instance = new ServiceProviderFactory();
    }
    return ServiceProviderFactory.instance;
  }

  public createGetAllServiceProvidersUseCase () {
    return new GetAllServiceProvidersUseCase(this.repository);
  }

  public createGetServiceProviderByIdUseCase () {
    return new GetServiceProviderByIdUseCase(this.repository);
  }

  public createCreateServiceProviderUseCase () {
    return new CreateServiceProviderUseCase(this.repository);
  }

  public createUpdateServiceProviderUseCase () {
    return new UpdateServiceProviderUseCase(this.repository);
  }

  public createDeleteServiceProviderUseCase () {
    return new DeleteServiceProviderUseCase(this.repository);
  }

  public createAssignBrandToProviderUseCase () {
    return new AssignBrandToProviderUseCase(this.repository);
  }

  public createUnassignBrandFromProviderUseCase () {
    return new UnassignBrandFromProviderUseCase(this.repository);
  }

  public createGetServiceProviderStatsUseCase () {
    return new GetServiceProviderStatsUseCase(this.repository);
  }

  public createGetProviderBrandsUseCase () {
    return new GetProviderBrandsUseCase(this.repository);
  }

  public createGetMyBrandsUseCase () {
    return new GetMyBrandsUseCase(this.repository);
  }

  public createGetBrandStoresUseCase () {
    return new GetBrandStoresUseCase(this.repository);
  }
}

// Export singleton instance
export const serviceProviderFactory = ServiceProviderFactory.getInstance();
